var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-loader"},[_c('v-skeleton-loader',{attrs:{"type":"paragraph"}}),_c('v-skeleton-loader',{attrs:{"type":"paragraph"}}),_c('v-skeleton-loader',{attrs:{"type":"paragraph"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }